import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ scrollMargin: number }>()(
  (theme, { scrollMargin }) => ({
    scrollTarget: {
      scrollMarginTop: theme.px(scrollMargin),
    },
  }),
);
